import React from "react";
import { Grid, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { mainBlue, mainGray, backgroundGray, highlightGray } from "../GlobalUtilities/Styles";
import { Link as RouterLink } from 'react-router-dom';
import FormatDate from "../GlobalUtilities/FormatDate";
import FarmImage from '../assets/card/farm-100-20.png';
import RowImage from '../assets/card/row-100-20.png';
import TreeImage from '../assets/card/tree-100-20.png';
import CattleImage from '../assets/card/cattle-100-20.png';

const JobCardStyle = styled(Box)(({ bu }) => {

    let backgroundImage;

    switch (bu) {
        case 'Permanent Plantings':
            backgroundImage = `url(${TreeImage})`;
            break;
        case 'Ranches':
            backgroundImage = `url(${CattleImage})`;
            break;
        case 'Row Crops':
            backgroundImage = `url(${RowImage})`;
            break;
        default:
            backgroundImage = `url(${FarmImage})`;
    }

    return {
        color: mainBlue,
        borderWidth: 0,
        borderRadius: 5,
        backgroundColor: backgroundGray,
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        height: '160px',
        padding: '0.5em',
        flex: '0 0 auto',
        backgroundSize: 'auto',
        backgroundPosition: 'bottom right',
        backgroundRepeat: 'no-repeat',
        textAlign: 'left',
        backgroundImage,
        backgroundSize: 'auto',
        backgroundPosition: 'bottom right',
        backgroundRepeat: 'no-repeat'
    }
});

const JobTitle = styled('div')`
    text-align:left;
    font-size: 1.1em;
    border-bottom: 1px dotted ${highlightGray};
    margin-bottom: 5px;
    padding-bottom: 5px;
    font-weight: bold;
    height: 40px;
`;

const JobDetails = styled('div')`
    margin-bottom:3px;
    padding:5px 0;
    font-size:0.9em;
    color: ${mainGray};
`;

const JobDetailsSmall = styled('div')`
    font-size:0.7em;
    color: ${mainGray};
    margin-bottom:20px;
`;

const JobLink = styled(RouterLink)`
    text-decoration: none;
    color: #699bbd;
`;

const JobCard = ({ job }) => {
    const path = `/jobdetail/${job.jobid}`;

    return (
        <JobCardStyle bu={job.division} >
            <Grid container>
                <Grid item md={12}>
                    <JobLink to={path}>
                        <JobTitle>{job.title}</JobTitle>
                    </JobLink>
                </Grid>
                <Grid item xs={12}>
                    <JobDetails>{job.location} | Job Id: {job.jobid}</JobDetails>
                </Grid>
                <Grid item xs={12}>
                    <JobDetailsSmall>Posted: < FormatDate rawDate={job.posted} /></JobDetailsSmall>
                </Grid>
                <Grid item xs={12}>
                    <JobLink to={path}>Find Out More...</JobLink>
                </Grid>
            </Grid>
        </JobCardStyle>
    )
}
export default JobCard;